import ReactComponent from '../MultiWiggleRendering';
import MultiLineRenderer from './MultiLineRenderer';
import configSchema from './configSchema';
export default (function (pluginManager) {
  pluginManager.addRendererType(function () {
    return new MultiLineRenderer({
      name: 'MultiLineRenderer',
      ReactComponent: ReactComponent,
      configSchema: configSchema,
      pluginManager: pluginManager
    });
  });
});